import { render, staticRenderFns } from "./bf-header.vue?vue&type=template&id=bab6ab5a&scoped=true&"
import script from "./bf-header.vue?vue&type=script&lang=js&"
export * from "./bf-header.vue?vue&type=script&lang=js&"
import style0 from "./bf-header.vue?vue&type=style&index=0&id=bab6ab5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab6ab5a",
  null
  
)

export default component.exports